export default async function({ app, route, store, redirect }) {
  try {
    const { data: user } = await app.$api.getMe()

    if (!user.has_subscription) {
      console.log('No subscription found')
      if (route.name !== 'no-subscription') {
        redirect('/no-subscription')
      }
      return
    }

    store.dispatch('auth/setUser', user)

    if (!user.is_read_terms && route.name !== 'terms') {
      // prevent infinite loop so to check route name
      redirect('/terms')
    }

    if (route.name === 'no-subscription') {
      console.log('In no subscription page but has subscription')
      redirect('/')
    }
  } catch (e) {} // let $axios.onError handles
}
